export const getIsoOffsetDate = ({
  dateOnly = true,
  offset = 0,
} = {}): string => {
  const d = new Date();
  const offsetDate = d.setDate(d.getDate() + offset);
  if (dateOnly) {
    return new Date(offsetDate).toLocaleDateString("en-CA", {
      timeZone: "Asia/Jakarta",
    });
  }
  return new Date(offsetDate).toLocaleDateString("en-CA", {
    timeZone: "Asia/Jakarta",
  });
};

export const getInitialsName = (fullname: string): string => {
  const name = fullname?.split(" ");
  let initial = fullname?.charAt(0);
  if (name.length > 1) {
    initial = name[0]?.charAt(0) + name[name.length - 1]?.charAt(0);
  }

  return initial;
};
